import React from 'react';

export interface BrandIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const BrandIconDefaultSize = 24;

export * from './Apple';
export * from './Facebook';
export * from './GoFundMe';
export * from './Google';
export { default as Instagram } from './Instagram';
export { default as Messenger } from './Messenger';
export * from './Outlook';
export * from './PayPal';
export { default as Pinterest } from './Pinterest';
export * from './Twitter';
export { default as YouTube } from './YouTube';
